import _implicitStylesheets from "./jsonPathPicker.css";

import _implicitScopedStylesheets from "./jsonPathPicker.scoped.css?scoped=true";

import _lightningTextarea from "lightning/textarea";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, k: api_key, d: api_dynamic_text, t: api_text, h: api_element, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [api_element("div", {
    classMap: {
      "container": true
    },
    attrs: {
      "spellcheck": false
    },
    key: 0
  }, [api_custom_element("lightning-textarea", _lightningTextarea, {
    className: $cmp.inputClass,
    props: {
      "label": $cmp.label,
      "value": $cmp.expr
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleChangeAC)),
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleChangeAC)),
      "selectionchange": _m2 || ($ctx._m2 = api_bind($cmp.handleSelectionAC)),
      "blur": _m3 || ($ctx._m3 = api_bind($cmp.handleBlurAC))
    }
  }, []), $cmp.searching ? api_element("section", {
    classMap: {
      "list-values": true
    },
    key: 2
  }, api_iterator($cmp.options, function (path, index) {
    return [!index ? api_element("p", {
      classMap: {
        "list-option": true,
        "option-hover": true
      },
      key: api_key(3, path),
      on: {
        "click": _m4 || ($ctx._m4 = api_bind($cmp.handleClickOption))
      }
    }, [api_text(api_dynamic_text(path))]) : null, index ? api_element("p", {
      classMap: {
        "list-option": true
      },
      key: api_key(4, path),
      on: {
        "click": _m5 || ($ctx._m5 = api_bind($cmp.handleClickOption))
      }
    }, [api_text(api_dynamic_text(path))]) : null];
  })) : null])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "util-jsonPathPicker_jsonPathPicker"
